import { render } from "./gif-selector.vue?vue&type=template&id=979db1c0&lang=pug"
import script from "./gif-selector.vue?vue&type=script&lang=js"
export * from "./gif-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__